import React from 'react';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import classNames from 'classnames';

import Add from '@material-ui/icons/Add';
import { withStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import strings from './components/language/language';

const styles = (theme) => ({
  container: {
    position: 'relative',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#f3f2f2',
    },
  },
  wrapper: {
    padding: 16,
    [theme.breakpoints.down('xs')]: {
      padding: '16px 15px',
    },
  },
  desktop: {
    [theme.breakpoints.up('md')]: {
      position: 'absolute',
      bottom: 6,
    },
    [theme.breakpoints.up('sm')]: {
      position: 'absolute',
      bottom: 6,
    },
    [theme.breakpoints.down('xs')]: {
      position: 'absolute',
      right: 75,
      bottom: 2,
    },
  },
  desktop1: {
    [theme.breakpoints.down('sm')]: {
      left: '90px !important',
    },
    [theme.breakpoints.down('xs')]: {
      left: '0px !important',
    },
  },
  name: {
    fontSize: 15,
    [theme.breakpoints.down('xs')]: {
      display: 'block',
      width: '87%',
    },
  },
  description: {
    width: '75%',
    display: 'block',
    color: '#0000008a',
    padding: '6px 0',
    fontFamily: 'Helvetica',
    fontSize: 14,
    lineHeight: '20px',
    [theme.breakpoints.down('sm')]: {
      width: '80%',
    },
    [theme.breakpoints.down('xs')]: {
      width: '80%',
    },
  },
  addContainer: {
    textAlign: 'right',
    position: 'absolute',
    right: 15,
  },
  add: {
    textAlign: 'center',
    position: 'relative',
    bottom: 40,
    cursor: 'pointer',
  },
  addButton: {
    color: '#70142c',
    padding: 5,
    border: '1px solid #70142c',
    borderRadius: theme.shape.borderRadius * 6,
    transition: 'all .3s ease-in-out',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.08)',
    },
  },
  mainPrice: {
    fontFamily: 'Helvetica',
  },
  promoCodePrice: {
    marginLeft: 10,
    fontSize: '18px !important',
    color: '#70142B',
    border: '1px solid #70142B',
    padding: 6,
    borderRadius: 30,
    [theme.breakpoints.down('sm')]: {
      fontSize: '17px !important',
    },
  },
  priceContainer: {
    display: 'flex',
    alignItems: 'center',
  },
});

const lineitem = (props) => {
  const { classes, url, description, name, promoCode, price, color } = props;

  // promo code for order item price
  const promoCodePrice = (price) => {
    const promoCodeDiscountOrder = (price / 100) * promoCode;
    const promoCodeOrder = price - promoCodeDiscountOrder;
    return (
      promoCode && (
        <div className={classNames(classes.promoCodePrice, 'item-price')}>
          {promoCodeOrder.toFixed(2)} {strings.currency}
        </div>
      )
    );
  };

  const promoCodeFirstPrice = (price) => {
    const promoCodeDiscountFirstOrder =
      (price[Object.keys(price).sort((a, b) => price[a] - price[b])[0]] / 100) *
      promoCode;
    const promoCodeFirstOrder =
      price[Object.keys(price).sort((a, b) => price[a] - price[b])[0]] -
      promoCodeDiscountFirstOrder;
    return (
      promoCode && (
        <div className={classNames(classes.promoCodePrice, 'item-price')}>
          {promoCodeFirstOrder.toFixed(2)} {strings.currency}
        </div>
      )
    );
  };

  // promo code for order item price
  // const promoCodeDiscountOrder = (price / 100) * promoCode;
  // const promoCodeOrder = price - promoCodeDiscountOrder;

  // description parse function
  const parseDescription = (description) => {
    // (desktop screen)
    if (window.innerWidth > 900) return description;

    // (if there is a pic [ mobile ])
    if (description.length > 25 && window.innerWidth < 400 && !url) {
      return description.slice(0, 40) + '...';
      // (if there is not a pic [ mobile ])
    } else if (description.length > 25 && window.innerWidth < 400 && url) {
      return description.slice(0, 28) + '...';
      // facebook tab
    } else if (description.length > 25 && window.innerWidth < 820) {
      return description.slice(0, 40) + '...';
    } else {
      return description;
    }
  };

  // title parse function
  const parseTitle = (name) => {
    if (window.innerWidth > 900) return name;
    if (name.length > 25 && window.innerWidth < 400 && !url) {
      return name.slice(0, 40) + '...';
      // (if there is not a pic [ mobile ])
    } else if (name.length > 25 && window.innerWidth < 400 && url) {
      return name.slice(0, 28) + '...';
      // facebook tab
    } else if (name.length > 25 && window.innerWidth < 820) {
      return name.slice(0, 40) + '...';
    } else {
      return name;
    }

    // // reduce the title ( mobile + facebook )
    // // facebook tab
    // if (name.length > 25 && window.innerWidth < 820) {
    //   return name.slice(0, 40) + '...';
    //   // mobile
    // } else if (name.length > 5 && window.innerWidth < 400 && url) {
    //   return name.slice(0, 5) + '...';
    // } else if (name.length > 1 && window.innerWidth < 400 && !url) {
    //   return name.slice(0, 1) + '...';
    // } else {
    //   return name;
    // }
  };

  const desktopVersion = url ? { position: 'relative', left: 90 } : { left: 0 };
  // const theButton = description
  //   ? { bottom: '50px important' }
  //   : { bottom: '40px important' };
  return (
    <div>
      <div
        className={classes.container}
        onClick={props.isNotAvailable ? null : props.click}
        disabled={props.isNotAvailable ? true : false}
      >
        <div id='line-item-grid' className={classes.wrapper}>
          <div style={desktopVersion} className={classes.desktop1}>
            <div id='sup-div-item' title={name}>
              <div className={classes.name}>{`${parseTitle(name)} ${
                props.isNotAvailable ? '❌' : ''
              }`}</div>
              <div className={classes.description}>
                {parseDescription(description)}
              </div>
              <div className={classes.priceContainer}>
                <div
                  className={classNames(classes.mainPrice, 'item-price')}
                  style={{
                    color: color,
                    textDecoration: promoCode ? 'line-through' : 'none',
                    fontWeight: promoCode ? 'normal' : 600,
                  }}
                >
                  {typeof price === 'number'
                    ? price + strings.currency
                    : 'from ' +
                      price[
                        Object.keys(price).sort(
                          (a, b) => price[a] - price[b]
                        )[0]
                      ] +
                      strings.currency}
                </div>
                {typeof price === 'number'
                  ? promoCodePrice(price)
                  : promoCodeFirstPrice(price)}
              </div>
            </div>
          </div>
          {/* show the image if EXIST */}
          {url ? (
            <div className={classes.desktop}>
              <div id='avatar-container'>
                <img id='avatar' src={url} />
              </div>
            </div>
          ) : null}
          {/* show the image if EXIST */}
          {/* Add button */}
          <div
            className={classes.addContainer}
            style={
              description
                ? { bottom: '50px !important' }
                : { bottom: '40px !important' }
            }
          >
            <ListItemIcon className={classes.add}>
              <Add
                className={classes.addButton}
                style={{ color: color, border: `1px solid ${color}` }}
              />
            </ListItemIcon>
          </div>
          {/* Add button */}
        </div>
      </div>
      <Divider />
    </div>
  );
};
export default withStyles(styles)(lineitem);



// WEBPACK FOOTER //
// ./src/LineItem.js